import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useNotWorkingStyles } from './styles';
import { schema } from './validation/schema';
import AppInput from '../../../../../../common/AppInput';
import AuthorizeCheckbox from '../authorizeThird/AuthorizeCheckbox';
import LoadingButton from '../../../../../../common/LoadingButton';
import { bodyTicketProductGenerator } from '../../../../../../../helpers/tickets/TicketsHelper';
import { createTicketNoProduct } from '../../../../../../../redux/actions/TicketActions';
import { validateDateFormat } from '../../../../../../../helpers/DateFormatter';

const NotWorking = ({ ...props }) => {
  const { mobile, motiveId, product, type, profile } = props;
  const classes = useNotWorkingStyles({ mobile });
  const [description, setDescription] = useState('');
  const [descriptionValidation, setDescriptionValidation] = useState('');
  const [date, setDate] = useState('');
  const [dateValidation, setDateValidation] = useState('');
  const [checked, setChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [error, setError] = useState(false);
  const [helper, setHelper] = useState('0/250');
  const [success, setSuccess] = useState(false);

  const { ticketNoProductStatus } = useSelector((state) => state.ticketReducer);
  const dispatch = useDispatch();

  const handleDate = (e) => {
    setDate(e.target.value);
  };

  const handleDescription = (e) => {
    const { value } = e.target;
    if (value.length <= 250) {
      setDescription(value);
      setHelper(`${value.length}/250`);
    }
  };

  const handleValidation = () => {
    if ('error' in schema.validate({ description })) {
      setDescriptionValidation('error');
      setErrorMessage(schema.validate({ description }).error.message);
    } else {
      setDescriptionValidation('valid');
      setErrorMessage('');
    }
  };

  const dateFormat = (e) => {
    const { value } = e.target;
    const isValid = validateDateFormat(value);

    setSuccess(isValid);
    setError(!isValid);
    setDateValidation(isValid ? 'valid' : 'error');
  };

  const sendData = () => {
    const dateReceiptProduct = date.split('/').reverse().join('-');

    const body = {
      fecha_recepcion_producto: dateReceiptProduct,
      ...bodyTicketProductGenerator({
        profile,
        type,
        motiveId,
        product,
        comment: description,
      }),
    };
    dispatch(createTicketNoProduct(body));
  };

  return (
    <Box className={classes.container}>
      <AppInput
        required
        name="dateInput"
        label="Fecha de recepción del producto"
        value={date}
        onClick={() => {}}
        onChange={handleDate}
        onBlur={dateFormat}
        success={success}
        errorMessage={'Formato de fecha incorrecto'}
        error={error}
        helperText={'DD/MM/AAAA'}
      />
      <AppInput
        required
        multiline
        name="descriptionInput"
        label="Descríbenos el inconveniente…"
        value={description}
        onClick={() => {}}
        onChange={handleDescription}
        onBlur={handleValidation}
        errorMessage={errorMessage}
        success={descriptionValidation === 'valid'}
        error={descriptionValidation === 'error'}
        helperText={helper}
      />
      <AuthorizeCheckbox
        idComplement="NotWorking"
        onCheck={() => setChecked(!checked)}
        disabled={
          descriptionValidation !== 'valid' || dateValidation !== 'valid'
        }
      />
      <LoadingButton
        name="NotWorking"
        text="Enviar"
        disabled={
          !checked ||
          descriptionValidation !== 'valid' ||
          dateValidation !== 'valid'
        }
        className={classes.sendButton}
        variant="contained"
        color="primary"
        loading={ticketNoProductStatus === 'loading'}
        onClick={sendData}
        data-cy="NotWorking"
      />
    </Box>
  );
};

NotWorking.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  onData: PropTypes.func,
};

export default NotWorking;
